export default __webpack_public_path__ + "485ba873138c0662b99fd9398e4a4aec.png";